(function (window, $) {
	window.app.register('dialog', function ($element, options) {
		var self = this;

		self.$el = $element;
		self.options = options;

		self.openNextAsReplacement = false;
		self.counter = 0;
		self._stack = [ ];
		self.dismissCallbacks = [ ];

		if (self.openNextAsReplacement) {
			self.peek()._remove();
		}

		var $dialog = this.element = bootbox.dialog({
			message: $element[0],
			backdrop: self.counter === 0 || self.openNextAsReplacement,
			animate: !self.openNextAsReplacement,
			size: 'large',

		}).on('shown.bs.modal', function() {
			// Je tu aby se nevolalo hide 2x
			$dialog.find('.bootbox-close-button').removeAttr('data-dismiss');
		}).on('hidden.bs.modal', function () {
			self._remove();
			self.destroy();
			self.dismissCallbacks.forEach(function (callback, index) {
				callback();
			});
		});

		if (self.options.modalDialogClass !== undefined) {
			$dialog.find('.modal-dialog').addClass(self.options.modalDialogClass);
		}

		$dialog.find('form :submit').on('click', function(e) {
			e.preventDefault();

			$(this).netteAjax(e).done(function (payload) {
				if ((payload.noErrors !== undefined) && (payload.noErrors === true)) {
					self.$el.c('dialog', 'hide');
				}
			})
		});

		self.setDialogFadeOnClose($dialog, true);
		self._stack.push(this);
		self.counter++;
		self.openNextAsReplacement = false;

	}, {
		availableCommands: [
			'getDialog', 'hide', 'onDismiss'
		],

		onDismiss: function (callback) {
			var self = this;
			self.dismissCallbacks.push(callback);
		},

		hide: function() {
			var self = this;
			this.element.modal('hide');
		},

		getDialog: function() {
			return this.element;
		},

		destroy: function() {
			var self = this;
			window.app.unbindComponentFromElement(self.$el, 'dialog');
		},

		peek: function() {
			var self = this;
			return self._stack[self._stack.length - 1];
		},

		setDialogFadeOnClose: function($dialog, boolean) {
			var self = this;
			if (boolean) {
				$dialog.addClass('fade');
				$dialog.next('.modal-backdrop').addClass('fade');

			} else {
				$dialog.removeClass('fade');
				$dialog.next('.modal-backdrop').removeClass('fade');
			}
		},

		_remove: function() {
			var self = this;

			// odebrat dialog ze stacku
			var idx = self._stack.indexOf(this);
			if (idx >= 0) {
				self.counter--;
				self._stack.splice(idx, 1);
			}

			// nahradit jeho snippet prázdným
			$('<div>').attr('id', this._id).appendTo(document.body);

			if (self.counter !== 0) {
				// BUGFIX: Ve vendoru, když se zavírá dialog, tak se odstraní z body tato třída.
				// Ta se má ale odstranit, až když se zavře poslední z otevřených dialogů. Bez
				// této třídy lze scrollovat v body a tím se nescrolluje v dialogu.
				$('body').addClass('modal-open');
			}
		}
	});

	$('[data-app-dialog-open]').on('click', function(e) {
		e.preventDefault();
		$(this).netteAjax(e, {}).done(function() {
			$('[data-app-dialog]').c('dialog', {});
		})
	});
}(window, jQuery));

